import { render, staticRenderFns } from "./RiskDetail.vue?vue&type=template&id=3a9bd407&scoped=true&"
import script from "./RiskDetail.vue?vue&type=script&lang=js&"
export * from "./RiskDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiskDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RiskDetail.vue?vue&type=style&index=1&id=3a9bd407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9bd407",
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/RiskDetail.vue"
export default component.exports